export const STATUS_CODES = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  NO_DATA: 441,
  INTERNAL_SERVER_ERROR: 500,
  INVALID_REQUEST: 404,
};
